var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2979 -0.00341797C6.11815 -0.00341797 0.297852 5.81688 0.297852 12.9966C0.297852 19.6533 5.30118 25.1415 11.7524 25.9057L13.7979 29.9966L15.8433 25.9057C22.2945 25.1415 27.2979 19.6533 27.2979 12.9966C27.2979 5.81688 21.4776 -0.00341797 14.2979 -0.00341797H13.2979Z",
    fill: "url(#paint0_linear_1956_1573)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1956_1573",
    x1: 27.2979,
    y1: 0.320371,
    x2: 0.880672,
    y2: 0.320371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8A24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLabel);
export default __webpack_public_path__ + "static/media/slider-label.d813d0d774edf7188d73e3689d4e8ef7.svg";
export { ForwardRef as ReactComponent };